const rail = {
  rails: "Bėgiai", // translated 
  senior: "Vyresnysis", // translated 
  seniors: "Senjorai", // translated 
  youths: "Jaunuoliai", // translated 
  yearOld: "Metų senumo", // translated 
  yearsOld: "metų", // translated 
};



export default rail;
